import { $, $$ } from '../utils/dom.js';
import { setupCustomCursor } from '../utils/custom-cursor.js';
import { Swiper } from '../vendor/vendor-globals.js';

export function initMediaSlider() {
  const disposers = $$('[data-component="media-slider"]').map((root) => setupMediaSlider(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupMediaSlider(root) {
  if (typeof Swiper !== 'function') {
    return () => {};
  }

  const viewport = $('.media-slider__viewport', root);
  const currentEl = $('[data-media-slider-current]', root);
  const totalEl = $('[data-media-slider-total]', root);
  const prevBtn = $('[data-media-slider-prev]', root);
  const nextBtn = $('[data-media-slider-next]', root);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideCount = $$('.media-slider__slide', viewport).length;

  if (!viewport || slideCount < 2) {
    return () => {};
  }

  if (totalEl) {
    totalEl.textContent = pad(slideCount);
  }

  const updateCounter = (swiper) => {
    if (currentEl) {
      currentEl.textContent = pad(swiper.realIndex + 1);
    }
  };

  const syncAria = (swiper) => {
    swiper.slides.forEach((slide) => {
      slide.setAttribute('aria-hidden', slide.classList.contains('is-active') ? 'false' : 'true');
    });
  };

  const swiper = new Swiper(viewport, {
    wrapperClass: 'media-slider__track',
    slideClass: 'media-slider__slide',
    slideActiveClass: 'is-active',
    slidesPerView: 1,
    loop: true,
    loopedSlides: slideCount,
    speed: reduceMotion ? 0 : 1500,
    grabCursor: false,
    allowTouchMove:true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
    on: {
      init(swiperInstance) {
        updateCounter(swiperInstance);
        syncAria(swiperInstance);
      },
      slideChange(swiperInstance) {
        updateCounter(swiperInstance);
        syncAria(swiperInstance);
      },
    },
  });

  const disposeCursor = setupCustomCursor(root, '[data-media-slider-cursor]');

  return () => {
    disposeCursor();
    swiper.destroy(true, true);
  };
}

function pad(value) {
  return String(value).padStart(2, '0');
}
